export default (prefix) => ({
  Request: `${prefix}_REQUEST`,
  Success: `${prefix}_SUCCESS`,
  Failure: `${prefix}_FAILURE`,
});
